<div class="dolomite-chat">
  <div class="dolomite-chat__sidebar">
    <atn-conversation-selector />
  </div>
  <div class="dolomite-chat__main">
    <div class="dolomite-chat__message-list">
      <atn-chat-message-list />
    </div>
    <div class="dolomite-chat__input">
      <atn-assistant-message-input
        class="atn-assistant-conversational__message-input"
        (submit)="submitMessage($event)"
        [allowFileAttachments]="true"
      />
    </div>
  </div>
</div>
